/**
 * 公共方法
 */
export default {
  _cacheUuid: '',
  /**
   * 获取GET字符串中的值
   * @param field
   * @returns {undefined}
   */
  getQueryField (field) {
    let retVal = undefined, search = window.location.search;
    if (search !== '') {
      let regStr = `([\?|&]?)${field}=([^=&]+)`;
      let myReg = new RegExp(regStr);
      if (myReg.exec(search)) {
        retVal = RegExp.$2;
      }
    }
    return retVal;
  },
  /**
   * 加载js
   * @param jsUrl
   * @param callback
   */
  loadJs (jsUrl, callback) {
    let eleNode = document.createElement('script');
    eleNode.defer = true;
    eleNode.type = 'text/javascript';
    eleNode.src = jsUrl;
    eleNode.onload = () => {
      if (this.getType(callback).indexOf('Function') > 0) {
        callback();
      }
    };
    document.body.appendChild(eleNode);
  },
  /**
   * 检查数据类型
   * @param data
   * @returns {string}
   */
  getType (data) {
    return Object.prototype.toString.apply(data);
  },
  /**
   * 判断元素是否在可见
   * @param eleId
   * @param iframeRect
   * @param pageType
   * @returns {boolean}
   */
  isElementInViewport (eleId, iframeRect, pageType) {
    let blnRet = false;
    try {
      let el = document.querySelector('#' + eleId);
      if (el.getBoundingClientRect) {
        let rect = el.getBoundingClientRect();
        iframeRect.stop = (iframeRect.stop || 0)
        iframeRect.wheight = (iframeRect.wheight || this.getQueryField('wheight'))
        blnRet = (
          rect.top > 220 && rect.top < (iframeRect.stop + (iframeRect.wheight) - (pageType === 'newtab' ? 285 : 147))
        );
      }
    } catch (e) {
      console.log('ele view err', e, arguments);
    }
    return blnRet;
  },
  /**
   * 获取浏览器加密处理过的uuid
   * @returns {string}
   */
  getUUID () {
    let retUUID = this._cacheUuid;
    if (retUUID === '') {
      try {
        if (!!chrome.ntp2345 && chrome.ntp2345.hasOwnProperty('getEncryptedUUID')) {
          retUUID = chrome.ntp2345.getEncryptedUUID();
        }
        if (retUUID.trim().length <= 0 && !!chrome.ntp2345 && chrome.ntp2345.hasOwnProperty('getUserMachineInfo')) {
          if (/uuid=([^&]+)&/.exec(chrome.ntp2345.getUserMachineInfo())) {
            retUUID = RegExp.$1;
          }
        }
      } catch (e) {
        console.log('chrome ntp2345 err');
      }
      this._cacheUuid = retUUID;
    }
    return retUUID;
  }
}
